export default __webpack_public_path__ + "static/media/bg2.e2b8710f.svg";